import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CarouselButton({
  icon: Icon,
  label,
  onClick,
  disabled = false,
}: {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      type="button"
      size="icon"
      variant="default"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="relative z-10 flex size-10 items-center justify-center rounded-full bg-[#948B7F] text-white transition-all duration-300 ease-in-out hover:bg-[#BFB7A1] hover:text-white cursor-pointer"
    >
      <Icon className="size-6 shrink-0" />
    </Button>
  );
}
